import * as React from "react";
import { Stack } from "@origin-digital/ods-core";
import {
  HeadingChevron,
  Text,
  HeadingLinkHoverContainer,
} from "@origin-digital/style-guide";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { routes } from "../../helpers/router.helper";

const MAX_HEADING_LENGTH_IN_ONE_LINE = 43;

const StyledText = styled(Text)`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export interface ITrendingItem {
  heading: string;
  summary: string;
  articleId: string;
  category: string;
  subcategory: string;
  isMultilineRow?: boolean;
}

const MULTILINE_HEADING_HEIGHT = "46px";
const HEADING_WIDTH = "275px";

const StyledLink = styled(Link)`
  text-decoration: none;
  height: ${({ height }: { height: string }) => height};
  display: -webkit-box;
  &:hover {
    cursor: pointer;
  }
`;

const StyledHeadingChevron = styled(HeadingChevron)`
  width: ${({ width }: { width: string }) => width};
`;

export const TrendingItem = ({
  articleId,
  heading,
  summary,
  category,
  subcategory,
  isMultilineRow,
}: ITrendingItem) => {
  const url = routes.article(category, subcategory, articleId, heading);
  const oneLineHeading = heading.length < MAX_HEADING_LENGTH_IN_ONE_LINE;
  return (
    <Stack space={["medium", "large"]} data-id={`trending-item-${articleId}`}>
      <StyledLink
        to={url}
        height={isMultilineRow ? MULTILINE_HEADING_HEIGHT : "auto"}
        data-id={`${articleId}-heading-link`}
      >
        <HeadingLinkHoverContainer>
          <StyledHeadingChevron
            data-id={`${articleId}-heading`}
            text={heading}
            width={oneLineHeading ? "auto" : HEADING_WIDTH}
          />
        </HeadingLinkHoverContainer>
      </StyledLink>
      <StyledLink to={url} data-id={`${articleId}-summary-link`}>
        <StyledText data-id={`${articleId}-summary`}>{summary}</StyledText>
      </StyledLink>
    </Stack>
  );
};
